import apiRequest from "../../helpers/apiRequest";

export default async (obj) => {
    return await apiRequest({
        method: 'post',
        url: `content/cancel/indvidual/appointment/`,
        data: obj
    });
}
